import { render, staticRenderFns } from "./BillingTopUpStepTwo.vue?vue&type=template&id=2d56e73e&"
import script from "./BillingTopUpStepTwo.vue?vue&type=script&lang=js&"
export * from "./BillingTopUpStepTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports